/*
 * Public API Surface of va-filter2-table
 */

export * from './lib/index';
